"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
class EventEmitter {
    /**
     * Create a new EventEmitter
     */
    constructor() {
        this.listeners = [];
        this.listenersOnce = [];
        this.emit = this.emit.bind(this);
        this.on = this.on.bind(this);
        this.once = this.once.bind(this);
    }
    /**
     * Emits the event to its subscribers
     * @param {Payload} payload
     */
    emit(payload) {
        for (const listener of [...this.listeners, ...this.listenersOnce]) {
            listener(payload);
        }
        this.listenersOnce = [];
    }
    /**
     * Unsubscribes the listener from the event
     * @param {Listener<Payload>} listener
     */
    off(listener) {
        const listenerIndex = this.listeners.indexOf(listener);
        if (listenerIndex > -1) {
            this.listeners.splice(listenerIndex, 1);
        }
    }
    /**
     * Subscribes a listener to the event
     * @param {Listener<Payload>} listener
     */
    on(listener) {
        this.listeners.push(listener);
    }
    /**
     * Subscribes the listener to receive the event exactly once
     * @param {Listener<Payload>} listener
     */
    once(listener) {
        this.listenersOnce.push(listener);
    }
    /**
     * Gives only a dummy info
     * @returns {IBusLogging}
     */
    get tabInfo() {
        return {
            broadcastType: "none",
            ownId: 1,
            idSet: new Set([1]),
        };
    }
}
exports.EventEmitter = EventEmitter;
